import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePurchaseSubscriptionContext } from '../../PurchaseSubscription/context/PurchaseSubscriptionContext';
import { useZendeskTroubleshootingTicket } from '../../ManageSubscription/Collar/hooks/useZendesk';
import * as gqlTypes from '../../../types/gql-op-types';
import { troubleshoot as events } from '../../../lib/analytics/events';

import styles from '../../ManageSubscription/styles/SubscriptionContainer.module.scss';
import SubscriptionAppBar from '../../ManageSubscription/components/SubscriptionAppBar';
import { TextArea } from '../../../components/TextArea/TextArea';
import Button from '../../../components/Button';
import ErrorScreen from '../../ManageSubscription/components/ErrorScreen/ErrorScreen';

export default function TroubleshootOtherReason() {
  const { t } = useTranslation();
  const { device } = usePurchaseSubscriptionContext();
  const [otherText, setOtherText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  events.pageLoad({ petId: device.pet?.id }, 'Other Reason');

  const { mutation, loading } = useZendeskTroubleshootingTicket({
    analyticsEvent: events.submittedOtherTroubleshootingReason,
    selectedTroubleshootingReason: gqlTypes.zendeskCancellationReason.OTHER,
    device,
    otherText,
  });

  if (loading) {
    return loading;
  }

  if (!device.subscription?.id) {
    return <ErrorScreen />;
  }

  const handleSubmit = () => {
    if (!otherText || !device.subscription?.id) {
      throw new Error(t('something_went_wrong'));
    }
    mutation({
      variables: {
        input: {
          recurlySubscriptionId: device.subscription.id,
          troubleshootingReason: gqlTypes.zendeskCancellationReason.OTHER,
          additionalText: otherText,
        },
      },
    });
    setSubmitted(true);
  };

  return (
    <>
      <div className={styles.fullWidthWrapper}>
        <SubscriptionAppBar
          backButtonAnalyticsEvent={() => events.otherReasonBack({ petId: device.pet?.id })}
          closeButtonAnalyticsEvent={() => events.otherReasonClose({ petId: device.pet?.id })}
        />
        <div className={styles.subscriptionContainer}>
          <h1>{t('let_us_know_what_happened')}</h1>
          <div className={styles.content}>
            <p>{t('can_you_please_describe_your_issue_well_have_customer_success_agent_contact_you')}</p>
            <div className={styles.textArea}>
              <TextArea
                onChange={(value) => {
                  value && setOtherText(value);
                }}
                rows={12}
                placeholderText={t('type_your_response_here')}
                disabled={submitted}
              />
            </div>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button className={styles.button} disabled={submitted} onClick={handleSubmit}>
            {submitted ? t('submitted') : t('submit')}
          </Button>
          {/* Spacer ensures primary button is aligned with buttons on neighboring pages in in-app cancel flow */}
          <div className={styles.buttonSpacer}></div>
        </div>
      </div>
    </>
  );
}
